import React from 'react';

interface TotalResultsHeaderProps {
  startRow: number;
  endRow: number;
  totalRows: number;
}

const TotalResultsHeader: React.FC<TotalResultsHeaderProps> = ({ startRow, endRow, totalRows }) => (
  <div className="text-grey-700 text-sm">
    Showing {startRow} to {endRow} of {totalRows} results
  </div>
);

export default TotalResultsHeader;
